const ComingSoon = ({ trello }) => {
  return (
    <div
      style={{
        backgroundColor: 'white',
        textAlign: 'left',
        padding: '4px',
        borderRadius: '8px',
        fontSize: '12px',
        height: 'fit-content',
        border: '1px solid #e0e0e0',
        boxShadow: '0px 1px 3px 0px #00000014',
      }}
    >
      <i>Coming Soon...</i>
      <div
        style={{
          display: 'flex',
          gap: '12px',
          marginTop: '4px',
        }}
      >
        {trello && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/workbench/trello.svg`}
              alt="trello icon"
              style={{ height: 24, width: 24 }}
            />
            <p style={{ margin: 0, padding: 0 }}>Trello Integration</p>
          </div>
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/workbench/notion.svg`}
            alt="notion icon"
            style={{ height: 24, width: 24 }}
          />
          <p style={{ margin: 0, padding: 0 }}>Notion Integration</p>
        </div>
      </div>
    </div>
  );
};
export default ComingSoon;
